define.alias("shared/helpers/-private/intl/t", "settings/helpers/t");